var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpstoxMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -3.2 34.2 34.2",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4452 6.88224C22.37 5.70277 23.776 4.92615 25.8952 4.92615C29.4454 4.92615 32.166 7.6464 32.166 11.4672C32.166 15.288 29.4454 17.8754 25.8952 17.8754C23.776 17.8754 22.37 17.0988 21.4452 15.9193V22.7968H18.8697V5.18779H21.4452V6.88224ZM21.4618 11.4672C21.4618 13.7597 23.1912 15.5704 25.5842 15.5704C27.9896 15.5704 29.5905 13.7555 29.5947 11.4672C29.5947 9.17473 27.9938 7.2311 25.5883 7.2311H25.5842C23.1788 7.23525 21.4618 9.17473 21.4618 11.4672ZM5.62792 11.8451C6.00532 11.5793 6.36199 11.2803 6.68963 10.9522C7.30343 10.3417 7.81356 9.63985 8.2034 8.87153V12.1857C8.2034 14.2456 9.33562 15.4334 11.2475 15.4334C13.2134 15.4334 14.7603 14.2456 14.7603 12.1857V5.18362H17.3317V17.6137H14.7437V16.048C14.329 16.6834 13.1429 17.8712 10.8411 17.8712C7.432 17.8712 5.62377 15.749 5.62377 12.7297L5.62792 11.8451ZM0 13.2696V10.7778C1.50133 10.7736 2.94045 10.1839 4.01046 9.14146C4.53302 8.62233 4.9519 8.00767 5.23806 7.33073C5.52423 6.64962 5.67353 5.92284 5.67353 5.18775H8.19925C8.19925 6.25093 7.98774 7.30165 7.57301 8.28178C7.16242 9.2619 6.55691 10.1507 5.79795 10.8982C4.251 12.4182 2.16905 13.2696 0 13.2696Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpstoxMark);
export default __webpack_public_path__ + "static/media/upstox-mark.29a91ebf0f308162f02f5f25fcc6d11e.svg";
export { ForwardRef as ReactComponent };